module.exports = __webpack_public_path__ + "img/sla.70b1434.svg";